import { render, staticRenderFns } from "./DynamicListSelectionToolbarExtensions.vue?vue&type=template&id=86b4c9f0"
import script from "./DynamicListSelectionToolbarExtensions.vue?vue&type=script&lang=js"
export * from "./DynamicListSelectionToolbarExtensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports